<template>
  <!-- 项目车次 -->
  <div>
    <!-- 头部-->
    <div class="child-head">
      <!-- 标题 -->
      <div class="child-head-left flex-center">
        <img src="../../assets/area_title.png" class="head-img" />
        <span>重点园区</span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="city-content city-content-chunk-box">
      <div class="city-box">
        <dv-scroll-board :config="config" style="width: 300px; height: 294px" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  watch: {
    dataList: {
      deep: true,
      immediate: true,
      handler() {
        this.v_datalist = this.dataList
        this.getProject()
      },
    },
  },
  data() {
    return {
      config: {
        header: ['园区名称', '所在城市'],
        data: [],
        rowNum: 8, //表格行数
        headerHeight: 32,
        headerBGC: '#033d7b', //表头
        oddRowBGC: '#042b63', //奇数行
        evenRowBGC: '#03326e', //偶数行
        align: ['left', 'left'],
        columnWidth: [216],
      },
      v_datalist: [],
    }
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    getProject() {
      var data1 = []
      this.v_datalist.forEach((item) => {
        data1.push([
          `<div style='color:${item.keynoteFlag == '2' ? '#01FFFD' : '#fff'}'>${
            item.name ? item.name : '--'
          }</div>`,
          `<div style='color:${item.keynoteFlag == '2' ? '#01FFFD' : '#fff'}'>${
            item.city ? item.city : '--'
          }</div>`,
          // item.name ? item.name : "--",
          // item.city ? item.city : "--",
        ])
      })
      this.config.data = data1
      this.config = { ...this.config } //关键,展开数组对象重新赋值.不写数据出不来
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/city.scss';

.city-content {
  height: 100%;

  .city-box {
    padding: 0px;
    overflow: hidden;
    width: 100%;
    height: 100%;

    .dv-scr-board {
      height: 100%;
    }

    .cj-1 {
      margin: 20px 20px;
    }

    .cj-box {
      background: inherit;
      background-color: rgba(26, 201, 255, 0.2980392156862745);
      height: 49px;
      font-size: 20px;
      line-height: 48px;
      padding-left: 10px;
      color: #1ac7fd;
    }

    .cj-box2 {
      width: 49%;
    }

    .cj-righ {
      margin-right: 10px;
    }

    .cj-2 {
      display: flex;
      align-content: center;
      width: 100%;
      margin-top: 15px;
    }
  }
}

::v-deep .header {
  color: #00a4ff;
}

.child-head {
  margin-bottom: 10px;
}
</style>
